var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBellIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#E0E8FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#F0F4FF",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 35V33H22V26C22 24.6167 22.4167 23.3875 23.25 22.3125C24.0833 21.2375 25.1667 20.5333 26.5 20.2V19.5C26.5 19.0833 26.6458 18.7292 26.9375 18.4375C27.2292 18.1458 27.5833 18 28 18C28.4167 18 28.7708 18.1458 29.0625 18.4375C29.3542 18.7292 29.5 19.0833 29.5 19.5V20.2C30.8333 20.5333 31.9167 21.2375 32.75 22.3125C33.5833 23.3875 34 24.6167 34 26V33H36V35H20ZM28 38C27.45 38 26.9792 37.8042 26.5875 37.4125C26.1958 37.0208 26 36.55 26 36H30C30 36.55 29.8042 37.0208 29.4125 37.4125C29.0208 37.8042 28.55 38 28 38ZM24 33H32V26C32 24.9 31.6083 23.9583 30.825 23.175C30.0417 22.3917 29.1 22 28 22C26.9 22 25.9583 22.3917 25.175 23.175C24.3917 23.9583 24 24.9 24 26V33Z",
    fill: "#213366"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/bell-icon.fc8ef257913a5906d2d7e366dbd2f634.svg";
export { ForwardRef as ReactComponent };